"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _rebass = require("rebass");

var _Icon = _interopRequireDefault(require("../Icon"));

var _Typography = require("../Typography");

var _Social = require("./Social.style");

var Social = function Social(_ref) {
  var media = _ref.media,
      size = _ref.size,
      text = _ref.text;
  return /*#__PURE__*/_react.default.createElement(_Social.SocialWrapper, null, /*#__PURE__*/_react.default.createElement(_rebass.Flex, {
    alignItems: "center"
  }, text && /*#__PURE__*/_react.default.createElement(_Social.SocialLabel, null, text), /*#__PURE__*/_react.default.createElement(_Social.SocialList, null, media && media.map(function (socialItem, key) {
    return socialItem.url && /*#__PURE__*/_react.default.createElement(_Social.SocialItemLink, Object.assign({
      key: key.toString(),
      to: socialItem.url,
      target: "_blank"
    }, socialItem), /*#__PURE__*/_react.default.createElement(_Icon.default, {
      name: socialItem.name,
      color: socialItem.color,
      size: size
    }), /*#__PURE__*/_react.default.createElement(_Typography.HiddenText, null, "Social Media Link"));
  }))));
};

Social.propTypes = {
  media: _propTypes.default.arrayOf(_propTypes.default.shape({
    name: _propTypes.default.string,
    url: _propTypes.default.string
  })),
  size: _propTypes.default.string,
  text: _propTypes.default.string
};
Social.defaultProps = {
  media: null,
  size: '24px',
  text: ''
};
var _default = Social;
exports.default = _default;